export default __webpack_public_path__ + "static/media/star.9767f1a5.svg";